import type { SVGProps } from 'react'
const IconPen2Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.6 6.924a.75.75 0 0 1 .173 1.046l-3.747 5.233A.14.14 0 0 0 4 13.29a.1.1 0 0 0 .037.07v.002c1.13 1.07 3.8 3.741 5.264 6.337a.1.1 0 0 0 .04.04.15.15 0 0 0 .069.016.13.13 0 0 0 .06-.015.1.1 0 0 0 .04-.041c1.47-2.59 4.123-5.254 5.268-6.332.037-.039.05-.103.008-.166L11.039 7.97a.75.75 0 1 1 1.22-.873l3.756 5.245a1.63 1.63 0 0 1-.192 2.102l-.01.01c-1.13 1.063-3.647 3.604-4.999 5.988l-.001.003c-.313.545-.866.81-1.403.81a1.61 1.61 0 0 1-1.41-.81l-.003-.005c-1.343-2.382-3.865-4.92-4.991-5.988a1.62 1.62 0 0 1-.208-2.111l.005-.007 3.75-5.237A.75.75 0 0 1 7.6 6.923"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.408 13.66a.75.75 0 0 1 .75.75v6.102a.75.75 0 0 1-1.5 0V14.41a.75.75 0 0 1 .75-.75"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.285 13.04a2.122 2.122 0 1 1 4.244 0 2.122 2.122 0 0 1-4.244 0m2.122-.622a.622.622 0 1 0 0 1.244.622.622 0 0 0 0-1.244M4.259 5.402a2.087 2.087 0 0 1 2.006-2.664h6.287a2.088 2.088 0 0 1 2.006 2.664l-.348 1.21a2.314 2.314 0 0 1-2.225 1.675H6.832a2.31 2.31 0 0 1-2.224-1.674zm2.006-1.164a.587.587 0 0 0-.565.75l.348 1.21c.1.348.42.589.783.589h5.155c.363 0 .682-.24.782-.589l.348-1.21a.588.588 0 0 0-.564-.75zM14.95 20.826c-.585.21-1.223.438-2.438.438a.75.75 0 0 1 0-1.5c.961 0 1.415-.164 1.917-.345l.012-.004c.585-.211 1.224-.438 2.438-.438s1.854.227 2.44.438l.013.004c.502.181.956.345 1.918.345a.75.75 0 1 1 0 1.5c-1.215 0-1.854-.227-2.44-.438l-.013-.005c-.502-.18-.956-.344-1.918-.344-.96 0-1.414.163-1.916.344z"
      clipRule="evenodd"
    />
  </svg>
)
export default IconPen2Icon
